"use client";

import { Children, isValidElement, type ReactNode } from "react";

import { HorizontalScroller } from "@jetblue/loyalty-uikit/horizontal-scroller";

type LoyaltyHorizontalScrollerClientProperties = {
  children?: ReactNode;
  itemsData: { id: string; title: string }[];
  regionAriaLabel: string;
  scrollMode: "page" | "item";
};

export const LoyaltyHorizontalScrollerClient = ({
  children,
  itemsData,
  regionAriaLabel,
  scrollMode,
}: LoyaltyHorizontalScrollerClientProperties) => {
  const childItems = Children.toArray(children ?? []);
  const slides = childItems.map((child, index) => {
    const itemData = itemsData[index];
    if (!itemData || !isValidElement(child)) {
      return null;
    }

    return (
      <HorizontalScroller.Item
        id={itemData.id}
        key={itemData.id}
        labels={{ title: itemData.title }}
      >
        <div className="flex flex-col gap-4">{child}</div>
      </HorizontalScroller.Item>
    );
  });

  return (
    <HorizontalScroller
      labels={{ regionAria: regionAriaLabel }}
      scrollMode={scrollMode}
      spaceBetweenItems={1}
    >
      {slides}
    </HorizontalScroller>
  );
};
